import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactMethods = () => {
  const contactMethods = [
    {
      icon: 'Phone',
      title: 'Call Us',
      description: 'Mon-Fri from 9am to 6pm IST',
      value: '+91 9811143590',
      action: 'tel:+91 9811143590',
      color: 'var(--color-success)'
    },
    {
      icon: 'Mail',
      title: 'Email Us',
      description: 'We respond within 24 hours',
      value: 'hello@devontis.com',
      action: 'mailto:hello@devontis.com',
      color: 'var(--color-accent)'
    },
    // {
    //   icon: 'MessageCircle',
    //   title: 'Live Chat',
    //   description: 'Available during business hours',
    //   value: 'Start a conversation',
    //   action: '#',
    //   color: 'var(--color-warning)'
    // },
    // {
    //   icon: 'MapPin',
    //   title: 'Visit Us',
    //   description: 'Our headquarters',
    //   value: '123 Tech Boulevard, San Francisco, CA 94105',
    //   action: '#',
    //   color: 'var(--color-destructive)'
    // }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-3 md:mb-4">
            Multiple Ways to Connect
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Choose the communication method that works best for you. We're here to help in whatever way is most convenient.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
          {contactMethods?.map((method, index) => (
            <a
              key={index}
              href={method?.action}
              className="group bg-background border border-border rounded-xl p-6 md:p-8 hover:border-primary hover:shadow-lg transition-all duration-300"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-muted rounded-lg flex items-center justify-center mb-4 md:mb-6 group-hover:bg-primary/10 transition-colors duration-300">
                  <Icon name={method?.icon} size={24} color={method?.color} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
                </div>
                <h3 className="text-lg md:text-xl font-semibold font-headline text-foreground mb-2">
                  {method?.title}
                </h3>
                <p className="text-xs md:text-sm text-muted-foreground font-body mb-3 md:mb-4">
                  {method?.description}
                </p>
                <p className="text-sm md:text-base font-medium text-primary font-body group-hover:underline">
                  {method?.value}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;